import { render } from "./PlayersListDraft.vue?vue&type=template&id=3e08a3c1&scoped=true"
import script from "./PlayersListDraft.vue?vue&type=script&lang=js"
export * from "./PlayersListDraft.vue?vue&type=script&lang=js"

import "./PlayersListDraft.vue?vue&type=style&index=0&id=3e08a3c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e08a3c1"]])

export default __exports__